<form [formGroup]="personalForm" (ngSubmit)="onSubmit()" class="info-form">
  <div class="info">
    <div class="profile-picture-container" (click)="updatePicture(profilePicture)">
      <gc-profile-picture [imgSrc]="profilePicture" [fullName]="fullName" class="profile"></gc-profile-picture>
      <mat-icon class="white-camera" svgIcon="camera"></mat-icon>
    </div>
    <div class="message">
      <div>
        <span class="overline">{{ 'photo' | translate }}</span>
      </div>
      <div>{{ 'keep_your_photo_up_to_date' | translate }}</div>
    </div>
  </div>
  <mat-form-field>
    <mat-label>{{ 'title' | translate }}</mat-label>
    <mat-select formControlName="title" disableOptionCentering gcFormField>
      <mat-option *ngFor="let title of titleOptions" [value]="title">
        {{ title | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'first_names' | translate }}</mat-label>
    <input matInput required type="text" formControlName="name" gcFormField (change)="initials()" />
    <mat-error *ngIf="personalForm.get('name').hasError('required')" [innerHTML]="'first_name_required' | translate"></mat-error>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'surname' | translate }}</mat-label>
    <input matInput required type="text" formControlName="surname" gcFormField />
    <mat-error *ngIf="personalForm.get('surname').hasError('required')" [innerHTML]="'surname_name_required' | translate"></mat-error>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'initials' | translate }}</mat-label>
    <input matInput type="text" formControlName="initials" gcFormField readonly="true" />
  </mat-form-field>
  <mat-form-field *ngIf="!idHidden">
    <mat-label>{{ 'id_type' | translate }}</mat-label>
    <mat-select formControlName="idtype" (selectionChange)="idtypeChange()">
      <mat-option *ngFor="let idtype of idtypes" [value]="idtype.value.toString()">
        {{ idtype.text | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field *ngIf="!idHidden">
    <mat-label>{{ 'id_number' | translate }}</mat-label>
    <input class="idnumber-field" matInput type="text" formControlName="idnumber" gcFormField (change)="populateDobAndGender()" />
    <mat-error *ngIf="personalForm.get('idnumber').hasError('pattern')" [innerHTML]="'valid_local_id' | translate"></mat-error>
    <mat-error *ngIf="personalForm.get('idnumber').hasError('required')" [innerHTML]="'id_number_required' | translate"></mat-error>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'date_of_birth' | translate }}</mat-label>
    <input
      matInput
      type="text"
      autocomplete="bday"
      [max]="maxDate"
      [matDatepicker]="dobPicker"
      formControlName="dob"
      (focus)="dobPicker.open()"
      gcFormField
      readonly
    />
    <mat-datepicker-toggle matSuffix [for]="dobPicker"></mat-datepicker-toggle>
    <mat-datepicker #dobPicker></mat-datepicker>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'gender' | translate }}</mat-label>
    <mat-select formControlName="gender" disableOptionCentering gcFormField>
      <mat-option class="gender-options" *ngFor="let gender of genderOptions" [value]="gender">
        {{ gender | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div class="save-info" *ngIf="editingUserAccount">
    <button class="btn-submit" type="submit" mat-raised-button color="primary">
      <mat-icon svgIcon="content-save"></mat-icon>
      {{ 'save_personal_information' | translate }}
    </button>
  </div>
</form>
